var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"self-empty bg-secondary py-5"},[_c('p',{staticClass:"self-letter-spacing-rem fs-4 text-white text-center fw-bold m-0"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }